<template>
    <div class="start-view">
        <div class="start-view__hero">
            <div class="start-view__project">
                <span>{{ !is_intl ? 'STOCRM' : 'RERADA' }} WiKi</span>
            </div>
            <div class="start-view__date">
                <span>{{ getTranslate('updated_title') }}</span>
            </div>
        </div>
        <div class="start-view__description">
            <span>{{ !is_intl ? 'STOCRM' : 'RERADA' }} {{ getTranslate('wiki_is_the_companys_knowledge') }} </span>
            <br>
            <br>
            <br>
            <span>{{ getTranslate('wiki_is_an_integral_part') }}</span>
        </div>
        <div class="start-view__icons">
            <a
                v-for="link in validLinks"
                :key="link.icon"
                class="start-view__icon"
                target="_blank"
                :href="!is_intl ? link.link.sto : link.link.rerada"
                @click="callCb($event, link.cb)"
            >
                <div class="start-view__icon-img">
                    <img
                        :src="link.icon"
                        alt="icon"
                    >
                </div>
                <div class="start-view__icon-text">
                    <span>{{ link.text }}</span>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StartView',
    data() {
        return {}
    },
    computed: {
        links() {
            return [
                {
                    icon: require('../assets/images/icon-plug.svg'),
                    text: this.getTranslate('tg_channel'),
                    link: {
                        sto: 'https://t.me/stocrm_news',
                        rerada: 'https://t.me/rerada'
                    }
                },
                {
                    icon: require('../assets/images/Refresh.svg'),
                    text: this.getTranslate('program_updates'),
                    link: {},
                    cb: () => {
                        if(!this.is_intl) {
                            const locationMap = {
                                'RU': '/wiki/ru/article/WIKI-A-1059',
                                'KZ': '/wiki/kz/article/WIKI-A-1070',
                                'EN': '/wiki/en/article/WIKI-A-1071',
                                'BY': '/wiki/by/article/WIKI-A-1072',
                                'AM': '/wiki/am/article/WIKI-A-1073',
                                'TR': '/wiki/tr/article/WIKI-A-1074',
                                'DE': '/wiki/de/article/WIKI-A-1075'
                            }
                            window.location = locationMap[this.workflowData.languageSystem]
                        } else {
                            if (this.workflowData.languageSystem === 'RU') {
                                window.location = '/wiki/ru/article/WIKI-A-812'
                            }
                        }
                    }
                },
                {
                    icon: require('../assets/images/youtube.svg'),
                    text: this.getTranslate('youtube_channel'),
                    link: {
                        sto: 'https://www.youtube.com/channel/UCoMG_ixCs7rwbHz3iwsy9Zw/videos',
                        rerada: ''
                    }
                },
                {
                    icon: require('../assets/images/ios.svg'),
                    text: this.getTranslate('ios_app'),
                    link: {
                        sto: 'https://apps.apple.com/ru/app/stocrm/id1446897204?l=en-GB',
                        rerada: ''
                    }
                },
                {
                    icon: require('../assets/images/Note.svg'),
                    text: this.getTranslate('technical_support'),
                    link: {
                        sto: '',
                        rerada: ''
                    },
                    cb: this.openCarrot
                },
                {
                    icon: require('../assets/images/android.svg'),
                    text: this.$root.getTranslate('android_app'),
                    link: {
                        sto: 'https://play.google.com/store/apps/details?id=com.stocrm.app',
                        rerada: 'https://play.google.com/store/apps/details?id=com.rerada.app'
                    },
                },
                {
                    icon: require('../assets/images/vk_play.svg'),
                    text: 'VK',
                    link: {
                        sto: 'https://vk.com/video/@stocrm',
                        rerada: ''
                    },
                },
                {
                    icon: require('../assets/images/random.svg'),
                    text: 'RUTUBE',
                    link: {
                        sto: 'https://rutube.ru/channel/35118747/',
                        rerada: ''
                    },
                },
            ]
        },
        validLinks() {
            return this.links.filter(link => {
                if (this.is_intl) {
                    return link.link.rerada || link.cb
                } else return link.link.sto || link.cb
            })
        }
    },
    methods: {
        callCb(event, cb) {
            if (!cb || typeof cb !== 'function') return
            event.preventDefault()
            cb()
        }
    }
}
</script>
<style scoped>
.start-view {
    margin-left: 20px;
}

.start-view .start-view__project span {
    font-weight: 600;
    color: var(--black);
    font-size: 24px;
    line-height: 28px;
}

.start-view .start-view__date {
    margin-top: 8px;
}

.start-view .start-view__date span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--muted-background);
}

.start-view .start-view__description span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--black);
}

.start-view .start-view__description {
    margin-top: 48px;
}

.start-view__icons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 24px;
    row-gap: 20px;
    max-width: fit-content;
    margin-top: 60px;
}

.start-view .start-view__icon {
    display: flex;
    align-items: center;
    column-gap: 20px;
    padding: 20px;
    background-color: var(--background-cultured);
    border-radius: 8px;
    width: 259px;
    cursor: pointer;
    text-decoration: none;
}

.start-view .start-view__icon .start-view__icon-text span {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: var(--additional-dark-blue);
}

.start-view .start-view__icon .start-view__icon-img {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.start-view .start-view__icon .start-view__icon-img img {
    width: 100%;
    height: 100%;
}

.start-view__icons {
    padding-right: 20px;
}

.start-view__icons::-webkit-scrollbar {
    display: none;
}

@media only screen and (max-width: 1024px) {
    .start-view__icons {
        overflow-x: auto;
    }

    .start-view__icon {
        height: 58px;
        width: 250px;
    }
}
</style>
